import { Info } from "lucide-react";
import { NewBadge } from "@/components/general/common/newBadge";

interface TestBannerProps {
    showNewBadge?: boolean;
}

export const TestBanner = ({ showNewBadge = false }: TestBannerProps) => {
    return (
        <div className="bg-linear-to-r from-blue-500/10 to-indigo-500/10 border border-blue-500/20 rounded-xl p-4">
            <div className="flex items-center gap-3">
                <div className="flex items-center justify-center w-10 h-10 rounded-full bg-blue-500/20">
                    <Info className="w-5 h-5 text-blue-500" />
                </div>
                <div className="flex-1">
                    <div className="flex items-center gap-2">
                        <h3 className="text-lg font-headline font-bold text-on-surface">Test Feature Banner</h3>
                        {showNewBadge && <NewBadge />}
                    </div>
                    <p className="text-sm text-on-surface mt-1">
                        This is a test feature banner to demonstrate the feature flag system.
                    </p>
                </div>
            </div>
        </div>
    );
};
